import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { DocumentType } from "@helper/abstraction/documents";
import { MessageType } from "@helper/abstraction/documents";
import { StatusDto } from "@helper/abstraction/documents";
import { UserBackendService } from "./user-backend.service";

export interface ExternalDocumentDto {
  messageType: MessageType;
  documentNumber: string;
}

@Injectable()
export class ExternalSourceDocumentOpenService {

  constructor(
		private readonly userBackendService: UserBackendService,
  ) { }

  public convertMsgTypeToDocumentType(messageType: MessageType): DocumentType | undefined {
    let documentType: DocumentType;
    switch (messageType) {
      case "BLRDLN":
      case "BLRDNR":
      case "BLRWBL":
      case "BLRWBR":
        documentType = "EWAYBILL";
        break;
      case "BLRADF":
        documentType = "EACTDIF";
        break;
      case "BLRINV":
        documentType = "EINVOICE";
        break;
      case "BLRPMT":
        documentType = "EINVOICEPMT";
        break;
      case "BLRSPT":
        documentType = "TRANSIT";
        break;
      default:
        documentType = messageType as DocumentType;
        break;
    }
    return documentType!;
  }

  public getDocument(document: ExternalDocumentDto): Observable<StatusDto> {
    return this.userBackendService.documents.externalDocument
      .post$(document.documentNumber, this.convertMsgTypeToDocumentType(document.messageType)!)
  }
}
